import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Cat from '../../../static/img/cat.svg';
import DarkLogo from '../../../static/img/dark-logo.svg';
import LogoOnly from '../../../static/img/logo-only.svg';
import Logo from '../../../static/img/logo.svg';
import Button from '../../components/Button';
import './landing-page.scss';

const DOCS_URL = 'https://docs.hyperunit.xyz';
const TESTNET_APP_URL = 'https://app.hyperunit-testnet.xyz';
const MAINNET_APP_URL = 'https://app.hyperunit.xyz';
const APP_URL = MAINNET_APP_URL;

const onClickDeposit = () => {
  window.location.href = APP_URL;
};

export default function Landing() {
  return (
    <div
      id="landing-page"
      className="flex flex-col items-center h-screen w-screen bg-rich-black overflow-y-auto relative no-scrollbar overflow-x-hidden"
    >
      <header className="flex flex-row flex-shrink-0 w-full h-[5.375rem] items-center py-6 px-10 mx-auto justify-between z-10 max-sm:px-4 max-sm:my-0 max-sm:h-16">
        <img alt="logo" className="h-7 max-sm:hidden" src={Logo as string} />
        <img
          alt="logo"
          className="h-7 md:hidden lg:hidden"
          src={LogoOnly as string}
        />
        <div className="flex flex-row items-center gap-6">
          <Link className="max-sm:text-sm" to={DOCS_URL} target="_blank">
            Docs
          </Link>
          <Button
            className="accent-shadow border border-white/[12%]"
            onClick={onClickDeposit}
          >
            Deposit Now
          </Button>
        </div>
      </header>
      <div className="flex flex-col w-full items-center my-16 max-sm:mt-8">
        <div className="relative">
          <DotLottieReact
            className="absolute top-24 left-[-15rem] w-64 h-full z-10 max-sm:left-[-4rem] max-sm:w-52 max-sm:opacity-50"
            src="/lottie/glowing-bg.lottie"
            loop
            autoplay
          />
          <DotLottieReact
            className="absolute top-[-3rem] right-[-15rem] w-64 h-full z-10 max-sm:right-[-4rem] max-sm:w-52 max-sm:opacity-50"
            src="/lottie/glowing-bg.lottie"
            loop
            autoplay
          />
          <div className="flex flex-col items-center gap-10 z-20 relative max-sm:gap-2">
            <div className="flex flex-col items-center max-sm:text-4xl max-sm:my-8 max-sm:gap-2">
              <div className="flex flex-row text-[3.75rem] leading-tighter items-center text-blue-jeans-50 font-pp-fragment-sans font-light gap-4 max-sm:h-fit max-sm:text-[1.75rem] max-sm:gap-2 max-sm:flex-wrap max-sm:justify-center">
                <span>Deposit native</span>
                <DotLottieReact
                  className="w-fit h-[4.875rem] max-sm:h-[3.5rem]"
                  src="/lottie/flipping-logo.lottie"
                  loop
                  autoplay
                />
                <span>to</span>
              </div>
              <div className="text-blue-jeans-500 text-[4.375rem] leading-tighter font-pp-eiko italic font-light text-accent-shadow max-sm:text-[3rem]">
                Hyperliquid
              </div>
            </div>
            <span className="text-center text-lg max-w-[30rem] text-cultured-white font-waldenburg max-sm:text-sm max-sm:px-4">
              Unit is the asset tokenization layer on Hyperliquid, enabling seamless deposits and withdrawals.
            </span>
            <Button
              className="accent-shadow !text-base py-4 max-sm:mt-8 border border-white/[12%]"
              onClick={onClickDeposit}
            >
              Deposit Now
            </Button>
          </div>
        </div>
      </div>
      <LiquidityRailPanel />
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <div className="flex flex-col items-center w-full gap-20 radial-gradient pt-36 max-sm:gap-8">
      <div className="flex flex-col items-center relative max-sm:justify-center max-sm:gap-2">
        <img className="absolute top-[-50%]" src={Cat as string} />
        {/* <div className="text-[2.75rem] font-light font-pp-fragment-sans max-sm:text-3xl">
          Sign up to get
        </div>
        <div className="text-[2.85rem] font-light font-pp-eiko italic max-sm:text-3xl">
          early beta access
        </div> */}
      </div>
      <Button
        className="!text-2xl text-blue-jeans-500 font-waldenburg py-6 !px-8 max-sm:!text-lg"
        secondary
        onClick={onClickDeposit}
      >
        Deposit Now
      </Button>
      <div className="flex flex-row items-start w-full p-10 gap-10 max-sm:p-8">
        <div className="max-sm:hidden">
          <img className="w-[14rem] max-sm:hidden" src={DarkLogo as string} />
        </div>
        <div className="flex flex-row flex-grow justify-end font-waldenburg gap-6 text-[#020000] font-semibold max-sm:text-xs max-sm:gap-4 max-sm:flex-wrap max-sm:justify-start">
          <div className="flex flex-col gap-5 w-44 max-sm:gap-3 max-sm:w-36">
            <div className="text-lg text-cultured-white font-normal max-sm:text-sm">
              Learn More
            </div>
            <Link className="text-[#020000]" to={DOCS_URL} target="_blank">
              Docs
            </Link>
          </div>
          <div className="flex flex-col gap-5 w-44 max-sm:gap-3 max-sm:w-36">
            <div className="text-lg text-cultured-white font-normal max-sm:text-sm">
              Community
            </div>
            <Link
              className="text-[#020000]"
              to="https://x.com/hyperunit"
              target="_blank"
            >
              X/Twitter
            </Link>
            <Link
              className="text-[#020000]"
              to="https://t.me/hyperunit"
              target="_blank"
            >
              Telegram
            </Link>
          </div>
          <div className="flex flex-col gap-5 w-44 max-sm:gap-3 max-sm:w-36">
            <div className="text-lg text-cultured-white font-normal max-sm:text-sm">
              Legal
            </div>
            <Link
              className="text-[#020000]"
              to={DOCS_URL + '/legal/terms-of-service'}
              target="_blank"
            >
              Terms of Service
            </Link>
            <Link
              className="text-[#020000]"
              to={DOCS_URL + '/legal/privacy-policy'}
              target="_blank"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function LiquidityRailPanel() {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-row items-start justify-center py-32 gap-16 max-sm:py-8 max-sm:gap-8 max-sm:flex-col">
        <div className="flex flex-col gap-2 leading-tighter text-charcoal-300 whitespace-nowrap w-fit max-sm:px-4 max-sm:flex-row max-sm:flex-wrap max-sm:justify-center">
          <div className="font-pp-fragment-sans font-light text-[3.25rem] max-sm:text-3xl">
            Spot
          </div>
          <div className="font-pp-eiko italic font-light text-blue-jeans-500 text-[3.75rem] max-sm:text-3xl">
            Liquidity Rail
          </div>
          <div className="font-pp-fragment-sans font-light text-[3.25rem] max-sm:text-3xl">
            for Hyperliquid
          </div>
        </div>
        <div className="flex flex-row w-full gap-16">
          <div className="flex flex-row gap-4 max-sm:flex-col">
            <div className="flex flex-col gap-4">
              <InfoCard
                label="Aligned"
                content="Initial Guardian set led by Unit, Hyperliquid Labs, and Infinite Field."
              />
              <InfoCard
                label="Seamless"
                content="Deposit or withdraw BTC via your own wallet or exchange account with 1 click direct on the Hyperliquid interface."
              />
            </div>
            <div className="relative flex flex-col gap-4">
              <InfoCard
                label="Secure"
                content="Advanced cryptography coupled with a distributed consensus mechanism to create resilient infrastructure."
              />
              <InfoCard
                label="Modular"
                content="Enables a unified self-custodial trading experience, new capital onramps, and portfolio margin."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoCard({
  label,
  content,
  className,
}: {
  label: string;
  content: string;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'h-[15.625rem] w-[21.875rem] bg-jungle-green hover:bg-[#1C324C] cursor-pointer transition-all gap-6 flex flex-col p-8 rounded-xl gradient-border max-sm:w-fit max-sm:mx-4 max-sm:p-6 max-sm:h-52',
        className,
      )}
    >
      <div className="text-[2rem] text-cultured-white font-pp-fragment-serif z-20 font-light max-sm:text-2xl">
        {label}
      </div>
      <div className="text-base font-waldenburg text-cultured-white/80 z-20 font-light max-sm:text-sm">
        {content}
      </div>
    </div>
  );
}
